import type { TriggerPrompt, WorkflowStep } from './scenario';

/** 解析平台旧版 JSON 字段；限制扫描量，丢弃非对象项，避免详情与会话对畸形 DTO 崩溃。 */
function records(value: unknown): Record<string, unknown>[] {
  if (typeof value !== 'string' || value.length > 128 * 1024) return [];
  try {
    const parsed: unknown = JSON.parse(value);
    return Array.isArray(parsed)
      ? parsed
          .slice(0, 50)
          .filter((item) => item && typeof item === 'object' && !Array.isArray(item))
      : [];
  } catch {
    return [];
  }
}

/** 返回完整的示例文本；不裁剪后再当作用户指令执行，过长条目直接忽略。 */
export function parseScenarioTriggers(value: unknown): TriggerPrompt[] {
  return records(value).flatMap((item) =>
    typeof item.label === 'string' &&
    item.label.trim() &&
    item.label.length <= 200 &&
    typeof item.prompt === 'string' &&
    item.prompt.trim() &&
    item.prompt.length <= 16000
      ? [
          {
            label: item.label,
            prompt: item.prompt,
            ...(typeof item.icon === 'string' ? { icon: item.icon } : {}),
          },
        ]
      : []
  );
}

/** 工作流详情与提示词使用同一有效条目序列；显示编号由数组位置生成。 */
export function parseScenarioWorkflow(value: unknown): WorkflowStep[] {
  return records(value).flatMap((item) =>
    typeof item.title === 'string' &&
    item.title.trim() &&
    item.title.length <= 500 &&
    (item.description === undefined ||
      (typeof item.description === 'string' && item.description.length <= 16000))
      ? [
          {
            title: item.title,
            description: typeof item.description === 'string' ? item.description : '',
          },
        ]
      : []
  );
}
